import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { paginacion } from "../../utils/paginacion/paginacion";
import { GrupoCard } from "./GrupoCard";
import { ShowButtonsPaginacion } from "../../utils/paginacion/ShowButtonsPaginacion";

const GRUPOS_POR_PAGINA = 6;

export const GrupoList = ({ grupos = [] }) => {
  const [paginaActual, setPaginaActual] = useState(1);

  const {
    objetosEnPagina: gruposEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, grupos, GRUPOS_POR_PAGINA);

  const mostrarGrupos = gruposEnPagina.length > 0;

  return (
    <section className="mx-auto px-4 py-8">
      <ul className="grid grid-cols-[repeat(auto-fit,_minmax(300px,_1fr))] gap-6 max-w-[1200px] mx-auto mb-2">
        {mostrarGrupos ? (
          gruposEnPagina.map((grupo) => (
            <GrupoCard key={grupo?.idGrupo} grupo={grupo} />
          ))
        ) : (
          <p className="col-span-full text-center text-gray-500">
            No hay grupos disponibles.
          </p>
        )}
      </ul>

      {paginas.length > 1 && (
        <div className="grid justify-center gap-1 pb-10">
          <ShowButtonsPaginacion
            paginaInicial={paginaInicial}
            paginaFinal={paginaFinal}
            paginaActual={paginaActual}
            setPaginaActual={setPaginaActual}
            paginas={paginas}
          />
        </div>
      )}
    </section>
  );
};
